import styled from "styled-components";

import { colors } from "global/globalStyle";

import BaseLabel from "components/BaseLabel";

import { BarStrongLevelProps } from "./interface";

export const BarWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 4px;
  width: 140px;
`;

export const Bar = styled.div<{ backgroundColor: string }>`
  height: 100%;
  flex: 1;
  background-color: ${(props) => props.backgroundColor};
  margin: 1px;
`;

export const TextBar = styled(BaseLabel)<BarStrongLevelProps>`
  font-size: 14px;
  margin-left: 4px;
  color: ${(props) => {
    switch (props.strongLevel) {
      case "weak":
        return colors.status_red;
      case "medium":
        return colors.status_yallow;
      case "strong":
        return colors.status_green;
      default:
        return colors.background_light;
    }
  }};
`;
